<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 我的创新券 -->

      <template v-if="hzdfDataList.length">
        <div v-for="(item, index) in hzdfDataList" :key="index">
          <JRtable :table-data="item.factDfsqxxVoList" :selection="false" :show-pagination="false"
            :column="currentUsersColumns" size="mini" :border="true" :index="true">
            <div class="innovationVoucher">
              <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
              <span>{{ item.hzdfjeJqdq ? '最终核准兑付金额：' : '最终核准兑付金额' }}</span>
              <span v-if="item.hzdfjeJqdq">
                <span style="color: red">{{ item.hzdfjeJqdq }}</span> 万元</span>
            </div>
          </JRtable>
        </div>
      </template>
      <template v-else>
        <JRtable :table-data="hzdfDataList" :selection="false" :show-pagination="false"
          :column="currentUsersColumns" size="mini" :border="true" :index="true">
          <div class="innovationVoucher">
            <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
            <span>{{ '最终核准兑付金额' }}</span>
          </div>
        </JRtable>
      </template>
    </div>
  </div>
</template>

<script>
import JRtable from '@/components/Table'
import { getFinalAmount } from '@/api/enterprise/exchangelist'
export default {
  components: {
    JRtable
  },
  data() {
    return {
      // 我的创新券
      hzdfDataList: [],
      currentUsersColumns: [
        {
          label: '兑付批次',
          prop: 'dfpc',
          align: 'center'
        },
        {
          label: '项目名称',
          prop: 'supportedProjectName',
          align: 'center'
        }
      ],
    }
  },
  mounted() {
    this.getFinalAmount()
  },
  methods: {
    // 查询最终核准兑付金额
    async getFinalAmount() {
      const result = await getFinalAmount()
      if (result.code === 200 && result.data != null) {
        this.hzdfDataList = result.data
      } else {
        this.hzdfDataList = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  max-height: 260px !important;
  overflow: auto !important;
}

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

::v-deep .el-table::before {
  background-color: transparent !important;
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }
}

/* 控制全选按钮样式 */
.select-popover-class .el-scrollbar__view>.el-checkbox {
  padding: 5px 20px;
}

/* 取消多选框触发事件 */
.select-popover-class .el-scrollbar__view>li .el-checkbox {
  pointer-events: none;
}

/* 隐藏多选框选中勾选样式 √ */
.select-popover-class .el-scrollbar__view>li::after {
  display: none;
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>
